import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const CommandeDetailsModal = ({ show, handleClose, commande }) => {
    if (!commande) return null;

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>Commande #{commande.id}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-9">
                            <h5 className='org-clr'>Détails de la commande</h5>
                            <div className="d-flex justify-content-between">
                                <p>Date de service: {commande.date_service}</p>
                                
                                <p>Statut de paiement: <span className="badge bg-warning text-dark">{commande.statut_paiement}</span></p>
                            </div>
                            <p>Statut de la commande: <span className="badge bg-primary">{commande.statut_commande}</span></p>
                            {commande.promo && (
                                <p>Code promo: {commande.promo.code}, Réduction: {commande.promo.discount}€</p>
                            )}
                            <hr />
                            <table className="table table-borderless table-responsive">
                                <thead>
                                    <tr>
                                        <th>Articles</th>
                                        <th>Quantité</th>
                                        <th>Addons</th>
                                        <th>Instructions</th>
                                        <th>Prix unitaire</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                               <tbody>
  {commande.plats.map((plat, index) => {
    // Calcul du total par plat
    const prixPlat = parseFloat(plat.prix) || 0;
    const prixAddons = plat.addons
      ? plat.addons.reduce((sum, addon) => {
          return (
            sum +
            addon.modules.reduce(
              (modSum, module) => modSum + (parseFloat(module.prix) || 0),
              0
            )
          );
        }, 0)
      : 0;
    const totalPlat = (prixPlat + prixAddons) * plat.quantite;

    return (
      <tr key={index}>
        <td className='col-2'>{plat.nom}</td>
        <td className='col-2'>{plat.quantite}</td>
        <td className='col-4'>
          {plat.addons.map((addon, idx) => (
            <div key={idx}>
              {addon.modules.map((module, modIndex) => (
                <div key={modIndex}>
                  <p>{module.nom} ({module.prix}€)</p>
                </div>
              ))}
            </div>
          ))}
        </td>
        <td className='col-4'>{plat.instructions}</td>
        <td className='col-2'>{prixPlat.toFixed(2)}€</td>
        <td className='col-2'>{totalPlat.toFixed(2)}€</td>
      </tr>
    );
  })}

  {/* Grand Total */}
  <tr>
    <td colSpan="5" className='font-weight-bold'>Grand Total</td>
    <td className='font-weight-bold'>
      {commande.plats
        .reduce((sum, plat) => {
          const prixPlat = parseFloat(plat.prix) || 0;
          const prixAddons = plat.addons
            ? plat.addons.reduce((s, addon) => {
                return s + addon.modules.reduce((mSum, module) => mSum + (parseFloat(module.prix) || 0), 0);
              }, 0)
            : 0;
          return sum + (prixPlat + prixAddons) * plat.quantite;
        }, 0)
        .toFixed(2)}€
    </td>
  </tr>
</tbody>

                            </table>
                        </div>
                        <div className="col-md-3">
                            <h5 className='org-clr'>Détails du client</h5>
                            <p>Prénom: {commande.prenom}</p>
                            <p>Nom: {commande.nom}</p>
                            <p>Numéro de téléphone: {commande.tele}</p>
                            <p>Email: {commande.email}</p>
                            <p>Adresse: {commande.adresse}</p>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CommandeDetailsModal;
